import React, { PureComponent } from 'react'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import _ from 'lodash'
import clsx from 'clsx'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import moment from 'moment'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'

import { FormsMergeWithState } from './forms.selector'
import { BaseContext } from '../theme.context'
import { FORM_SET_PENDING_FORM } from '../../actions'

export class FormDetailContainer extends PureComponent {
  static contextType = BaseContext

  componentDidMount() {
    this.context.onChangeleftButton(false)
  }

  render = () => {
    const {
      submissions,
      classes,
      point,
      form,
      history,
      searchDetails,
      match,
      isPending,
      setPendingForm,
      formsPointsSelected,
    } = this.props

    if (searchDetails) {
      return (
        <Container fixed className={classes.fullHeight}>
          <Grid
            container
            justify='center'
            alignItems='center'
            className={clsx(classes.fullHeight, classes.root)}
          >
            <Grid
              item
              xs={12}
              md={6}
              className={clsx(classes.fullHeight, classes.content)}
            >
              <Paper className={clsx(classes.paper, classes.paperBody)}>
                <Typography gutterBottom variant='h5'>
                  {'Buscando respuestas'}
                </Typography>
                <LinearProgress color='secondary' />
              </Paper>
            </Grid>
          </Grid>
        </Container>
      )
    }

    return (
      <Container fixed className={classes.fullHeight}>
        <Grid
          container
          justify='center'
          alignItems='center'
          className={clsx(classes.fullHeight, classes.root)}
        >
          <Grid
            item
            xs={12}
            md={6}
            className={clsx(classes.fullHeight, classes.content)}
          >
            <Paper className={clsx(classes.paper, classes.paperTitle)}>
              <Grid container wrap='nowrap' spacing={2}>
                <Grid item xs zeroMinWidth>
                  <Typography noWrap>
                    Formulario: {form.name}
                  </Typography>
                  <Typography noWrap>
                    Punto: {point.name}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
            <Paper className={clsx(classes.paper, classes.paperBody)}>
              {!submissions.length && (
                <div className={classes.withoutSubmissions}>
                  <Typography gutterBottom>
                    {'No hay respuestas para mostrar.'}
                  </Typography>
                </div>
              )}
              {submissions.map(stage => (
                <div key={stage.key} className={classes.questionGroup}>
                  <Typography gutterBottom variant='h5'>
                    {stage.title}
                  </Typography>
                  {stage.submissions.map((submission, index) => (
                    <div key={`${stage}-${index}`}>
                      <Typography className={classes.question}>
                        {submission.label}
                      </Typography>
                      <Typography className={classes.value}>
                        {submission.value}
                      </Typography>
                      <br />
                    </div>
                  ))}
                </div>
              ))}
            </Paper>
            <div className={classes.contentButton}>
              {isPending && (
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.button}
                  onClick={() => setPendingForm(formsPointsSelected)}
                >
                  {'Continuar con el formulario'}
                </Button>
              )}
              <Button
                variant='contained'
                className={classes.button}
                onClick={() => {
                  if (match.path === '/dashboard/forms/new/detail/:id') {
                    return history.replace('/dashboard')
                  }

                  history.goBack()
                }}
              >
                {'Cerrar'}
              </Button>
            </div>
          </Grid>
        </Grid>
      </Container>
    )
  }
}

const mapStateToProps = (store, props) => {
  const {
    Forms: {
      formsPoints,
      submissions: allSubmissions,
      searchDetails,
    },
    Points: { data: points },
  } = store

  if (searchDetails) {
    return {
      searchDetails,
      submissions: [],
      point: {},
      form: {},
    }
  }

  const { match: { params: { id } } } = props
  const { formsKeyed } = FormsMergeWithState(store)
  const pointsKeyed = _.keyBy(points, '_id')
  const formsPointsKeyed = _.keyBy(formsPoints, '_id')
  const formsPointsSelected = formsPointsKeyed[id]

  if (!formsPointsSelected) {
    return {
      submissions: [],
      point: {},
      form: {},
    }
  }

  const pointsSelected = pointsKeyed[formsPointsSelected.point_id] || {}
  const formSelected = formsKeyed[formsPointsSelected.form_id]

  if (!formsPointsSelected.stage_id) {
    return {
      submissions: [],
      point: pointsSelected,
      form: formSelected,
      isPending: !formsPointsSelected.finalize,
      formsPointsSelected,
    }
  }

  const isReactiveForm = formSelected.type === 'reactive'
  const stageSelected = _.find(formSelected.funnel.stages, { _id: formsPointsSelected.stage_id })
  const filterStages = isReactiveForm
    ? formSelected.funnel.stages
    : formSelected.funnel.stages.filter(stage => stage.order <= stageSelected.order)
  const allQuestionsGroups = _.flattenDeep(filterStages.map(stage => stage.questionsGroups))
  const allQuestions = _.flattenDeep(
    allQuestionsGroups.map(questionGroup => questionGroup.questions),
  )
  const questionsGroupKeyed = _.keyBy(allQuestionsGroups, '_id')
  const questionsKeyed = _.keyBy(allQuestions, '_id')
  const allSubmissionsGrouped = _.groupBy(allSubmissions, 'form_point_id')
  const allSubmissionsFilter = allSubmissionsGrouped[formsPointsSelected._id]
  const submissionsByStages = _.reduce(allSubmissionsFilter, (acum, submission) => {
    const question = questionsKeyed[submission.question_id]
    const questionGroup = questionsGroupKeyed[question.question_group_id]
    const acumStage = acum[questionGroup.stage_id]

    if (!acumStage) {
      return {
        ...acum,
        [questionGroup.stage_id]: {
          key: questionGroup._id,
          title: questionGroup.name,
          order: questionGroup.order,
          submissions: [{
            label: question.label,
            value: submission.value,
          }],
        }
      }
    }

    return {
      ...acum,
      [questionGroup.stage_id]: {
        ...acumStage,
        submissions: _.orderBy(acumStage.submissions.concat({
          label: question.label,
          value: question.type === 'Date'
            ? moment(new Date(submission.value)).format('DD/MM/YYYY')
            : submission.value,
        }), 'order')
      }
    }
  }, {})

  const submissions = isReactiveForm
    ? Object.keys(submissionsByStages).map(key => submissionsByStages[key])
    : filterStages.map(stage => submissionsByStages[stage._id])

  return {
    submissions: _.compact(submissions),
    point: pointsSelected,
    form: formSelected,
    isPending: !formsPointsSelected.finalize,
    formsPointsSelected,
  }
}

const mapDispatchToProps = dispatch => ({
  setPendingForm: formPoint => dispatch(FORM_SET_PENDING_FORM(formPoint)),
})

const useStyles = theme => ({
  fullHeight: { height: '100%' },
  root: {
    boxSizing: 'border-box',
    padding: 25,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  paper: {
    boxSizing: 'border-box',
    padding: 25,
    width: '100%',
  },
  paperTitle: {
    height: 95,
    marginBottom: 20,
  },
  paperBody: {
    maxHseight: 'calc(100% - 145px)',
    overflowY: 'auto',
  },
  questionGroup: {
    marginBottom: 20,
  },
  question: {
    opacity: 0.5,
  },
  value: {
    opacity: 1,
    color: 'rgb(79, 108, 141)'
  },
  withoutSubmissions: {
    textAlign: 'center',
  },
  contentButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: `0 -${theme.spacing(1)}px`,
  },
  button: {
    margin: theme.spacing(1),
  },
})

export default compose(
  withRouter,
  withStyles(useStyles),
  connect(mapStateToProps, mapDispatchToProps),
)(FormDetailContainer)
